export default "__VITE_ASSET__45c46829__"